export default __webpack_public_path__ + "static/media/b-7.fbeeba5e.png";